/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_DeleteInputs */



/**
* | output |
* | --- |
* | "Can I delete a tournament?" |
*
* @param {Og_Faq_Q_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_delete = /** @type {((inputs?: Og_Faq_Q_DeleteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_DeleteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Puis-je supprimer un tournoi ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Puedo eliminar un torneo?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Posso excluir um torneio?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posso eliminare un torneo?")
	return /** @type {LocalizedString} */ ("Can I delete a tournament?")
});